<template>
    <div class="grid-content">
        <div class="box-filter">
            <el-form ref="ruleForm" @submit.prevent v-on:submit.prevent>
                <div class="viewFilter">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="{span: 4, offset: 2}">
                            <el-form-item prop="periodo_cadastro" label="Período de Cadastro">
                                <el-date-picker 
                                    format="dd/MM/yyyy" 
                                    value-format="yyyy-MM-dd" 
                                    style="width: 100%" 
                                    v-model="ruleForm.periodo_cadastro" 
                                    type="daterange" 
                                    @handleValue="(x) => { ruleForm.periodo_cadastro = x; this.filterFields(); }" 
                                    start-placeholder="Inicio" end-placeholder="Fim"
                                    @change="filterFields"
                                >
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4">
                            <el-form-item prop="marketplace_id" label="Marketplace">
                                <SelectSearchMarketplace 
                                    :model="ruleForm.marketplace_id" 
                                    :isEdit="false"
                                    @handleValue="(x) => { ruleForm.marketplace_id = x; this.filterFields(); }"
                                    @change="filterFields"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4">
                            <el-form-item prop="department_store_id" label="Estabelecimento/Documento">
                                <SelectSearchDepartamentStore 
                                    :model="ruleForm.department_store_id" 
                                    :isEdit="false" 
                                    @handleValue="(x) => { ruleForm.department_store_id = x; this.filterFields(); }"
                                    @change="filterFields"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4">
                            <el-form-item prop="button">
                                <el-button
                                    @click="filterFields('export')"
                                    type="success"
                                    size="large"
                                    style="height: 65px;font-size: 20px;"
                                >
                                Exportar Lista!
                                </el-button>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="4">
                            <el-form-item prop="button">
                                <el-button
                                    @click="clearSearch()"
                                    type="default"
                                >
                                Limpar Filtros
                                </el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
        </div>
        <div class="grid-content">
            <el-row class="LinhaSetas">
                <SetaOnboarding 
                    status="Análise" 
                    substatus="de Risco" 
                    :text_help="statusMessages['risk_analysis']" />
                <SetaOnboarding 
                    status="Dados" 
                    substatus="Bancários" 
                    :text_help="statusMessages['bank_account']" />
                <SetaOnboarding 
                    status="Adquirente"
                    :text_help="statusMessages['acquirers']" />
                <SetaOnboarding 
                    status="Planos" 
                    :text_help="statusMessages['plan']" />
                <SetaOnboarding 
                    status="Gateway" 
                    :text_help="statusMessages['gateway']" />
                <SetaOnboarding 
                    status="Terminais"
                    :text_help="statusMessages['terminal']" />
                <SetaOnboarding 
                    status="Prontos" 
                    substatus="para Ativar"
                    :text_help="statusMessages['ready']" />
            </el-row>
            <el-row class="LinhaSetas">
                <QuadrosOnboarding 
                    :ammount_processing="(countStatus.risk_analysis + countStatus.risk_analysis_manually)" 
                    :ammount_pending="(countStatus.risk_analysis_reproved + countStatus.risk_analysis_awaiting + countStatus.risk_analysis_error + countStatus.risk_analysis_rejected)" 
                    :filter_status_processing="['risk_analysis', 'risk_analysis_manually']"
                    :filter_status_pending="['risk_analysis_reproved', 'risk_analysis_awaiting', 'risk_analysis_error', 'risk_analysis_rejected']"
                    :is_active="ruleForm.status"
                    @handleValue="setStatus"
                    @handleSomaStatus="handleSomaStatus" />
                <QuadrosOnboarding 
                    :ammount_processing="(countStatus.bank_account)" 
                    :ammount_pending="(countStatus.bank_account_reproved + countStatus.bank_account_error)" 
                    :filter_status_processing="['bank_account']"
                    :filter_status_pending="['bank_account_reproved', 'bank_account_error']"
                    :is_active="ruleForm.status"
                    @handleValue="setStatus"
                    @handleSomaStatus="handleSomaStatus"/>
                <QuadrosOnboarding 
                    :ammount_processing="(countStatus.acquirers)" 
                    :ammount_pending="(countStatus.acquirers_reproved + countStatus.acquirers_error)" 
                    :filter_status_processing="['acquirers', 'acquirers_approved']"
                    :filter_status_pending="['acquirers_reproved', 'acquirers_error']"
                    :is_active="ruleForm.status"
                    @handleValue="setStatus"
                    @handleSomaStatus="handleSomaStatus"/>
                <QuadrosOnboarding 
                    :ammount_processing="(countStatus.plan)" 
                    :ammount_pending="(countStatus.plan_reproved)" 
                    :filter_status_processing="['plan']"
                    :filter_status_pending="['plan_reproved']"
                    :is_active="ruleForm.status"
                    @handleValue="setStatus"
                    @handleSomaStatus="handleSomaStatus" />
                <QuadrosOnboarding 
                    :ammount_processing="(countStatus.gateway)" 
                    :ammount_pending="(countStatus.gateway_reproved + countStatus.gateway_error)" 
                    :filter_status_processing="['gateway']"
                    :filter_status_pending="['gateway_reproved', 'gateway_error']"
                    :is_active="ruleForm.status"
                    @handleValue="setStatus"
                    @handleSomaStatus="handleSomaStatus"/>
                <QuadrosOnboarding 
                    :ammount_processing="(countStatus.terminal)" 
                    :ammount_pending="(countStatus.terminal_reproved)" 
                    :filter_status_processing="['terminal']"
                    :filter_status_pending="['terminal_reproved']"
                    :is_active="ruleForm.status"
                    @handleValue="setStatus"
                    @handleSomaStatus="handleSomaStatus" />
                <QuadroOnboarding 
                    :ammount="countStatus.active"
                    :filter_status="['active']"
                    :is_active="ruleForm.status"
                    @handleValue="setStatus" />
            </el-row>
        </div>
    </div>
</template>

<script>
    import SelectSearchMarketplace from "@/app/components/Marketplace/SelectSearchMarketplace";
    import SelectSearchDepartamentStore from "@/app/components/EstabelecimentoComercial/SelectSearchDepartamentStore";
    import SetaOnboarding from "@/app/components/Onboarding/SetaOnboarding";
    import QuadrosOnboarding from "@/app/components/Onboarding/QuadrosOnboarding";
    import QuadroOnboarding from "@/app/components/Onboarding/QuadroOnboarding";

    export default {
        name: "FilterBox",
        props: ["countStatus", "total"],
        components: {
            SelectSearchMarketplace,
            SelectSearchDepartamentStore,
            SetaOnboarding,
            QuadrosOnboarding,
            QuadroOnboarding,
        },
        data() {
            const data_atual = new Date();
            var data_inicio = data_atual.getFullYear() + '-' + (data_atual.getMonth() + 1) + '-01';
            var data_fim = data_atual.getFullYear() + '-' + (data_atual.getMonth() + 1) + '-' + data_atual.getDate();
            return {
                statusMessages: {
                    "risk_analysis": "A Análise de Risco permite verificarmos se o EC e seus responsáveis estão em condições legais de operar conosco.",
                    "bank_account": "Aqui analisamos se o documento informado possui relação com a conta bancária informada. Realizamos também a verificação se os dados bancários são válidos para realizar transferências. Dica: cadastrar a conta digital Cappta ajuda o processo ser mais rápido!",
                    "acquirers": "Nesta etapa enviamos seu cadastro para Adquirência. Isso permite que você possa associar um plano ao estabelecimento.",
                    "plan": "Aqui você vê os estabelecimentos que estão para ter o plano associado. Caso você tenha tentado associar e tenha dado errado, você pode visualizar por aqui como prosseguir.",
                    "gateway": "Essa etapa consiste em preparar o estabelecimento no ambiente de captura de transações.",
                    "terminal": "Na penúltima etapa, quando tudo estiver ok, você poderá associar terminais aos estabelecimentos. As eventuais pendências também são mostradas aqui caso existirem.",
                    "ready": "Por fim, aqui você verá os estabelecimentos que já passaram por todas as etapas, mas que ainda não transacionaram."
                },
                query: "?onboarding=1",
                loadingPage: true,
                ruleForm: {
                    periodo_cadastro: [data_inicio, data_fim],
                    marketplace_id: null,
                    department_store_id: null,
                    status: [],
                }
            };
        },
        methods: {
            clearSearch() {
                const data_atual = new Date();
                var data_inicio = data_atual.getFullYear() + '-' + (data_atual.getMonth() + 1) + '-01';
                var data_fim = data_atual.getFullYear() + '-' + (data_atual.getMonth() + 1) + '-' + data_atual.getDate();
                this.query = "?onboarding=1";
                this.ruleForm.periodo_cadastro = [data_inicio, data_fim];
                this.ruleForm.marketplace_id = null;
                this.ruleForm.department_store_id = null;
                this.ruleForm.status = [];
                this.filterFields();
            },
            setStatus(status) {
                if(this.ruleForm.status.includes(status[0])) {
                    this.ruleForm.status = this.ruleForm.status.filter(status_item => !status.includes(status_item));
                } else {
                    this.ruleForm.status = this.ruleForm.status.concat(status);
                }
                this.filterFields('status');
            },
            handleSomaStatus(status) {
                if(this.isAllStatusIncluded(status)) {
                    this.ruleForm.status = this.ruleForm.status.filter(status_item => !status.includes(status_item));
                } else {
                    var concatArr = this.ruleForm.status.concat(status);
                    this.ruleForm.status = concatArr.filter((item, idx) => concatArr.indexOf(item) === idx);
                }
                this.filterFields('status');
            },
            isAllStatusIncluded(status){
                return status.every(s => this.ruleForm.status.includes(s))
            },
            filterFields(searchMethod) {
                this.query = `?onboarding=1`;

                if (this.ruleForm.periodo_cadastro) {
                    this.query = `${this.query}&periodo_cadastro=${this.ruleForm.periodo_cadastro}`;
                }
                if (this.ruleForm.marketplace_id) {
                    this.query = `${this.query}&marketplace_id=${this.ruleForm.marketplace_id}`;
                }
                if (this.ruleForm.department_store_id) {
                    this.query = `${this.query}&department_store_id=${this.ruleForm.department_store_id}`;
                }
                if (searchMethod == 'export' || searchMethod == 'status') {
                    if (this.ruleForm.status.length >= 1) {
                        this.query = `${this.query}&status=${this.ruleForm.status}`;
                    }
                }

                if(searchMethod == 'export') {
                    this.$emit("filterExport", this.query);
                } else if (searchMethod == 'status') {
                    this.$emit("filterStatus", this.ruleForm);
                } else {
                    this.$emit("filterList", this.query);
                }
            }
        }
    };
</script>

<style scoped>
    @media only screen and (min-width: 767px) {
        .LinhaSetas {
            justify-content: center;
            display: flex;
        }
    }
</style>
